(function() {
  "use strict";

  const selectors = {
      toggleButton: '.csh-aem-base-text__plusbutton',
      description: '.csh-aem-base-text__description',
      toggleIcon: '.csh-aem-base-text__plusIcon',
  };

  const addClickToggle = () => {
      const toggleButtons = document.querySelectorAll(selectors.toggleButton);
      toggleButtons.forEach((button, index) => {
          const textDescription = document.querySelectorAll(selectors.description)[index];
          const toggleIcon = document.querySelectorAll(selectors.toggleIcon)[index];

          button.addEventListener("click", () => {
              textDescription.classList.toggle('show');
              toggleIcon.classList.toggle('minus');
              const toggleButtonAriaExpandedAttr = button.getAttribute("aria-expanded");
              if (toggleButtonAriaExpandedAttr === "true") {
                  button.setAttribute("aria-expanded", "false");
              } else {
                  button.setAttribute("aria-expanded", "true");
              }
          });
      });
  };

  const onDocumentReady = () => {
      addClickToggle();
  };

  if (document.readyState !== "loading") {
      onDocumentReady();
  } else {
      document.addEventListener("DOMContentLoaded", onDocumentReady);
  }
}());